import { render, staticRenderFns } from "./ProfileLabalaguereContact.vue?vue&type=template&id=56edb87f"
import script from "./ProfileLabalaguereContact.vue?vue&type=script&lang=js"
export * from "./ProfileLabalaguereContact.vue?vue&type=script&lang=js"
import style0 from "./ProfileLabalaguereContact.vue?vue&type=style&index=0&id=56edb87f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports